import { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

type TableHeaderProps = {
  title?: string;
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 16px;
  gap: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.dec.color.primary.default.sk.norm};
  background-color: ${({ theme }) => theme.dec.color.primary.default.bg.norm};
`;

const Title = styled.div`
  flex-grow: 1;
`;

export function TableHeader({ title, children }: PropsWithChildren<TableHeaderProps>) {
  return (
    <Container>
      {title && <Title>{title}</Title>}
      {children}
    </Container>
  );
}
